// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"callouts_wrapper__2AbZG","container":"callouts_container__18i0H","callout":"callouts_callout__1FdVN","title":"callouts_title__toiOz"};